// id is used to fetch the data from the object that we use
// title is the title of the column/the displayed text
// width is the width of the column (not used)
// onClick is the function that is called when the column is clicked
// priority is the priority of the column, for mobile table, depending on screensize the amount of priorities are displayed
export const columns = [
	{
		id: 'name',
		title: 'Name',
		width: 250,
		priority: 1,
		isKey: true,
	},
	{
		id: 'email',
		title: 'Email',
		width: 250,
		priority: 2,
	},

	{
		id: 'role',
		title: 'Role',
		width: 150,
		priority: 3,
	},
];
